import { render } from "./OwnerDetails.vue?vue&type=template&id=c186a7ec&scoped=true"
import script from "./OwnerDetails.vue?vue&type=script&lang=js"
export * from "./OwnerDetails.vue?vue&type=script&lang=js"

import "./OwnerDetails.vue?vue&type=style&index=0&id=c186a7ec&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+comp_4cebc095a9b5bcc882fa23a41973ce86/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c186a7ec"]])

export default __exports__